<template>
  <div name="hrms12x-detail-notsend" id="hrms12x-detail-notsend">
    <div class="modal-header header-popup">
      <button type="button" class="close" data-dismiss="modal">&times;</button>
      <h4 class="modal-title">{{ labels['HRMS12X']['140'] }}</h4>
    </div>
    <div class="modal-body detail detail-responsive"> 
      <div class="detail detail-responsive">
        <div class="box-body">
          <div class="col-md-2 panel-left"/>
          <div class="col-md-8 form-horizontal">
            <div class="form-group">
              <label class="col-sm-3 control-label">{{ labels['HRMS12X']['160'] }}</label>
              <div class="col-sm-9">
                <input type="input" readonly="readonly" class="form-control" :value="data.rows[0].sender_id + ' - ' + data.rows[0].sender_name">
              </div>
            </div>
            <div class="form-group">
              <label class="col-sm-3 control-label">{{ labels['HRMS12X']['170'] }}</label>
              <div class="col-sm-9">
                <input type="input" readonly="readonly" class="form-control" :value="data.rows[0].sender_email">
              </div>
            </div>
          </div>
          <hrms-table  :columns="columns" 
                       :data="data"
                       :searchDisp="true" /> 
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'hrms12x-detail-notsend',
  props: [ 'labels', 'data', 'nowLang', 'columns' ]
}
</script>

<style lang="scss">

.sendmail-box {
  background: #FFF;
  box-shadow: 0 1px 1px 0 rgba(0,0,0,0.3);
  border-top: 1px solid #d2d6de;
}

</style>



// WEBPACK FOOTER //
// detailNotSend.vue?6e90cf44